import { useEffect, useState } from "react";
import styled from "styled-components";
import ShoesImage from "../../assets/images/hero/hero-3.png";
import AccessoriesImage from "../../assets/images/hero/hero-4.png";
import FloatingChatButton from "../../components/button/FloatingChatButton";
import Footer from "../../components/footer/Footer";
import Navbar from "../../components/navbar/Navbar";
import ProductGallery from "../../components/product/ProductGallery";
import H2 from "../../components/typography/H2";
import { productService } from "../../service/ProductService";
import CategoryWithImages from "./components/CategoryGallery";
import CategoryHeroLarge from "./components/CategoryHeroLarge";
import CategoryHeroSmall from "./components/CategoryHeroSmall";
import HeroImage from "./components/HeroImage";
import SaleBanner from "./components/SaleBanner";
import SocialsSection from "./components/SocialsSection";

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: hidden;
`;
const Center = styled.div`
  padding: 35px;
  text-align: center;
`;
const MobileMargin = styled.div``;
const Margin = styled.div`
  margin: auto 5%;
  padding: 2px;
`;
const Space = styled.div`
  height: 35px;
`;
const CategoryHeros = styled.div`
  margin-top: -4px;
  padding: 0px;
  width: 100%;
  display: flex;
`;
function HomePage() {
  const [latestProducts, setLatestProducts] = useState();
  useEffect(() => {
    const fetchProducts = async () => {
      productService.getProductsByFlag(
        "latest",
        1,
        (products) => {
          setLatestProducts(products);
        },
        {
          default: (err) => {
            alert(err);
          },
        },
      );
    };
    fetchProducts();
  }, []);
  return (
    <Wrapper>
      <FloatingChatButton />
      <Navbar />
      <HeroImage />
      <MobileMargin>
        <Center>
          <H2>New Arrivals</H2>
        </Center>
        {latestProducts && (
          <ProductGallery
            products={latestProducts}
            navigateTo={"/products/flag/latest"}
          />
        )}
        <Space />
      </MobileMargin>
      <Space />
      <SaleBanner />
      <Space />
      <Margin>
        <CategoryWithImages />
      </Margin>
      <Space />
      <Space />
      <CategoryHeroLarge />
      <CategoryHeros>
        <CategoryHeroSmall categoryName={"Bags"} imageUrl={ShoesImage} />
        <CategoryHeroSmall
          categoryName={"Footwear"}
          imageUrl={AccessoriesImage}
        />
      </CategoryHeros>
      <Space />
      <Space />
      <Margin>
        <SocialsSection />
      </Margin>
      <Space />
      <Space />
      <Footer />
    </Wrapper>
  );
}

export default HomePage;
